import { render, staticRenderFns } from "./detailsQuizzParent.vue?vue&type=template&id=262370f1&"
import script from "./detailsQuizzParent.vue?vue&type=script&lang=js&"
export * from "./detailsQuizzParent.vue?vue&type=script&lang=js&"
import style0 from "./detailsQuizzParent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports